module.exports = __webpack_public_path__ + "img/title.a3e8ad60.png";